// src/router/index.js
import { createRouter, createWebHistory } from "vue-router";
import Hello from "@/views/HelloWorldTst.vue";
import Admin from "@/views/admin/AdminIndex.vue";

const routes = [
  {
    path: "/",
    name: "Hello",
    component: Hello,
    meta: { 
      title: "默认",
      keepAlive: false,
      requiresLogin: true,
    },
  },
  {
    path: "/admin",
    name: "Admin",
    component: Admin,
    meta: { 
      title: "首页",
      keepAlive: false,
      requiresLogin: true,
    },
  },
  {
    path: "/web",
    name: "Web",
    component: () => import("../views/web/WebHome.vue"),
    meta: { 
      title: "我的应用",
      keepAlive: false,
      requiresLogin: false,
    },
  },
  {
    path: "/h5_hel",
    name: "H5_hel",
    component: () => import("@/views/h5/hel/AboutPage.vue"),
    meta: { 
      title: "about",
      keepAlive: false,
      requiresLogin: false,
     },
  },
  {
    path: "/h5_tst",
    name: "H5_tst",
    component: () => import("@/views/h5/tst/JavaDemo.vue"),
    meta: { 
      title: "JavaDemo",
      keepAlive: false,
      requiresLogin: false,
     },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL), // 使用 HTML5 History 模式
  routes,
});


export default router;
